// @flow
import React, {Fragment} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import routerActions from '../../actions/router';
import IconButton from '../IconButton/IconButton';
import {CLOSE__24} from '@homeaway/svg-defs';
import {FormattedMessage} from 'react-intl';
import gql from 'graphql-tag';

import './PinnedProperty.less';

export const fragments = {
    PinnedPropertyHit: gql`
        fragment PinnedPropertyHit on SERPHit {
            available
            pinned
        }
    `
};
export type SERPHitShape = {
    listingId: string,
    available: boolean,
    pinned: boolean
};

type DispatchProps = {
    removePinnedProperty: typeof routerActions.removePinnedProperty
};

type Props = {
    children: any,
    datesUnavailable: boolean,
    guestCountExceeded: boolean,
    label?: string,
    petsNotAllowed: boolean,
    numResults: number
} & DispatchProps;

const getDefaultTitle = () => {
    return (
        <FormattedMessage
            id={'pinnedPropertyAlt'}
            description="Pinned property default label"
            defaultMessage="Featured property"
        />
    );
};

const getTitle = (
    datesUnavailable: boolean,
    guestCountExceeded: boolean,
    petsNotAllowed: boolean,
    label?: string
) => {
    switch (true) {
        case guestCountExceeded:
            return (
                <FormattedMessage
                    id={'pinnedPropertyGuestsDeclined'}
                    description="This property requires fewer guests"
                    defaultMessage="This property requires fewer guests"
                />
            );
        case petsNotAllowed:
            return (
                <FormattedMessage
                    id={'pinnedPropertyPetsDeclined'}
                    description="This property does not allow pets"
                    defaultMessage="This property does not allow pets"
                />
            );
        case datesUnavailable:
            return (
                <FormattedMessage
                    id={'pinnedPropertyUnavailable'}
                    description="This property is unavailable on your dates"
                    defaultMessage="This property is unavailable on your dates"
                />
            );

        default:
            return label ? (
                <FormattedMessage
                    id={label}
                    description="Pinned property custom label"
                    // $FlowFixMe
                    defaultMessage={getDefaultTitle()}
                />
            ) : (
                getDefaultTitle()
            );
    }
};

const getNearbyPropertiesTitle = () => {
    return (
        <h2 className="HitCollection_nearbyTitle">
            <FormattedMessage
                id="expandedSearchNearbyLabel"
                description="Nearby property label"
                defaultMessage="You might like these nearby properties"
            />
        </h2>
    );
};

export const PinnedProperty = ({
    children,
    datesUnavailable,
    guestCountExceeded,
    label,
    petsNotAllowed,
    numResults,
    removePinnedProperty
}: Props) => {
    const nearbyProperties = numResults > 1;

    const handleDismiss = () => {
        edapTrigger(GENERIC_EVENT, {
            eventaction: 'dismiss',
            eventcategory: 'pinned-property'
        });
        removePinnedProperty();
    };

    return (
        <Fragment>
            <div className="PinnedProperty">
                <div className="bg--color-brand PinnedContainer--container">
                    <div className="PinnedContainer--header">
                        <h4>
                            {getTitle(
                                datesUnavailable,
                                guestCountExceeded,
                                petsNotAllowed,
                                label
                            )}
                        </h4>
                        <IconButton
                            markup={CLOSE__24}
                            onClick={handleDismiss}
                            data-wdio="close"
                        />
                    </div>
                    {children}
                </div>
            </div>
            {nearbyProperties && getNearbyPropertiesTitle()}
        </Fragment>
    );
};

const mapDispatchToProps = {
    removePinnedProperty: routerActions.removePinnedProperty
};

export default compose(
    connect(
        null,
        mapDispatchToProps
    )
)(PinnedProperty);
